export const homeObjTwo = {
  id: 'resume',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'RESUME',
  headLine: 'Thanks for your interest',
  description: 'Please click \'Here\' to view larger !',
  buttonLabel: 'Here',
  imgStart: true,
  img: require('../../images/resume.png').default,
  alt: 'Piggybank',
  dark: false,
  primary: false,
  darkText: true
}

